import { computed, ref } from 'vue';
import { tagColors, useSurveyStore } from '/@/app/store/surveys';
import _ from 'lodash';

export function useSurvey() {
  const studentId = ref();
  const surveyStore = useSurveyStore();

  const studentEnrollment = computed(() =>
    surveyStore.enrollments.find(
      enrollment => enrollment.user.id === studentId.value,
    ),
  );
  const submissions = computed(() =>
    _.reduce(
      studentEnrollment.value?.summary.flatMap(
        questionnaire => questionnaire.records,
      ),
      (acc, { question, answer }) => ({ ...acc, [question.id]: answer }),
      {},
    ),
  );
  const needsList = computed(
    () =>
      studentEnrollment.value?.summary.flatMap(element => ({
        ...element.questionnaire,
        theme: element.questionnaire.display.themeColor,
      })) ?? [],
  );
  const questionsBlocks = computed(() => {
    const blocks = studentEnrollment.value?.summary.flatMap(element =>
      element.records.map(record => ({
        ...record,
        questionnaire: element.questionnaire,
        submitted_at: element.submitted_at,
      })),
    );
    return _.uniqBy(blocks, block => block.title.id) ?? [];
  });
  const areasList = computed(
    () =>
      _.reduce(
        questionsBlocks.value,
        (acc, { question }) =>
          Array.from(new Set([...acc.concat(question?.tags)])),
        [],
      ).map(tag => ({ id: tag, title: tag, theme: tagColors[tag] })) ?? [],
  ); //

  const getAreaQuestion = activeSurvey => {
    return (
      questionsBlocks.value?.filter(block =>
        block.question.tags.includes(activeSurvey),
      ) ?? []
    );
  };
  const getNeedQuestion = activeSurvey => {
    return (
      questionsBlocks.value?.filter(
        block =>
          block.questionnaire.id == activeSurvey && block.question.tags.length,
      ) ?? []
    );
  };

  const getOpenQuestion = () => {
    return questionsBlocks.value?.filter(block => !block.question?.tags.length);
  };

  const getSubmission = ques => {
    if (!submissions.value[ques.question.id]) return 'Didn\'t answer yet';
    if (ques.question.name === 'textarea')
      return submissions.value[ques.question.id][0].text;

    return ques.question.content.options
      .filter(option => submissions.value[ques.question.id].includes(option.id))
      .flatMap(option => option.title)
      .join(', ');
  };

  const getBadgeText = (isArea, ques) => {
    if (isArea) {
      return ques.questionnaire.title;
    }
    return ques.question.tags.join('');
  };

  const getBadgeTheme = (isArea, ques) => {
    if (isArea) {
      return ques.questionnaire.display.themeColor;
    }
    return tagColors[ques.question.tags.join('')];
  };
  return {
    studentId,
    studentEnrollment,
    submissions,
    needsList,
    areasList,
    getAreaQuestion,
    getNeedQuestion,
    getOpenQuestion,
    getSubmission,
    getBadgeText,
    getBadgeTheme,
  };
}
